// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AFty","colBig":"styles_colBig__1kPOK","colSmall":"styles_colSmall__qzSWe"};